import React, { Component } from "react";
import bandit from "../images/cropped/bandit_squish.avif";
import cauchy from "../images/cropped/cauchy.avif";
import dali_sleepy from "../images/cropped/dali_sleepy.avif";
import two from "../images/dali_cauchy.avif";
import two2 from "../images/cropped/cuddle.avif";
import two3 from "../images/jump.avif";

class Tiles extends Component {
  render() {
    return (
      <div className="tiles">
        <div className="section-heading">
          <h1>Chinchilla Facts</h1>
          <div className="shadow">Chinchillas Facts</div>
        </div>

        <div className="tiles-wrapper">
          <div className="tile tile-1">
            <div className="flip-tile-inner">
              <div className="flip-tile-front">
                <img
                  src={bandit}
                  alt="Bandit squeezed in between a wooden house and a cage platform"
                />
              </div>
              <div className="flip-tile-back">
                <h4>Their life expectancy is up to 20 years</h4>
              </div>
            </div>
          </div>

          <div className="tile tile-2">
            <div className="flip-tile-inner">
              <div className="flip-tile-front">
                <h4>Chinchillas can jump up to 1 meter high</h4>
              </div>
              <div className="flip-tile-back">
                <img
                  src={two3}
                  alt="A collage of freeze-frames of Bandit mid-jump, seen from different angles"
                />
              </div>
            </div>
          </div>

          <div className="tile tile-3">
            <div className="flip-tile-inner">
              <div className="flip-tile-front">
                <img
                  src={dali_sleepy}
                  alt="Dalí sleeping in his clay house, laying in the entrance, an eye half opened"
                />
              </div>
              <div className="flip-tile-back">
                <h4>
                  They are crepuscular, which means they're mostly active during
                  dusk and dawn
                </h4>
              </div>
            </div>
          </div>

          <div className="tile tile-4">
            <div className="flip-tile-inner">
              <div className="flip-tile-front">
                <h4>
                  Chinchillas always must be kept at least in pairs of two
                </h4>
              </div>
              <div className="flip-tile-back">
                <img
                  src={two2}
                  alt="All three chinchilla cuddled up to one another, Bandit and Cauchy facing the camera, Dalí showing his fluffy butt and tail"
                />
              </div>
            </div>
          </div>

          <div className="tile tile-5">
            <div className="flip-tile-inner">
              <div className="flip-tile-front">
                <img
                  src={cauchy}
                  alt="Cauchy sitting upright on a clay tunnel, staring into the camera"
                />
              </div>
              <div className="flip-tile-back">
                <h4>
                  Chinchillas are intelligent rodents and can learn some tricks
                </h4>
              </div>
            </div>
          </div>

          <div className="tile tile-6">
            <div className="flip-tile-inner">
              <div className="flip-tile-front">
                <h4>
                  Their stomachs are sensitive and they can't have too many
                  treats
                </h4>
              </div>
              <div className="flip-tile-back">
                <img
                  src={two}
                  alt="Dalí and Cauchy sitting on their owner's leg, treats in their hands"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Tiles;
